"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ipv4ToHex = exports.ipvHexToV4 = void 0;
/**
 * Converts an IP HEX string to V4 format.
 * @param ipHex Ip in HEX format
 */
exports.ipvHexToV4 = function (ipHex) {
    var withoutPrefix = ipHex.slice(2);
    var part1 = ipHex.slice(2, 4);
    var part2 = ipHex.slice(4, 6);
    var part3 = ipHex.slice(6, 8);
    var part4 = ipHex.slice(8);
    var parts = [part1, part2, part3, part4];
    var toV4 = parts.map(function (ipHexPart) { return parseInt(ipHexPart, 16); }).join(".");
    return toV4;
};
/**
 * Converts an IP V4 string to hex format.
 * @param ipv4 Ip in V4 format
 */
exports.ipv4ToHex = function (ipv4) {
    var manualToHex = ipv4
        .split(".")
        .map(function (ipSection) { return parseInt(ipSection).toString(16).padStart(2, "0"); })
        .join("");
    // Add the prefix
    var ipAsHex = "0x" + manualToHex;
    return ipAsHex;
};
//# sourceMappingURL=ipHexConversionUtils.js.map